export default "__VITE_PUBLIC_ASSET__b8b814f1__"